import { DatePipe } from '@angular/common';
import { Component, input, OnInit, signal } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { finalize } from 'rxjs';
import { MedicalHistoryModalComponent } from '../../../../../components/modals/medical-history-modal/medical-history-modal.component';
import { CardComponent } from '../../../../../shared/components/card/card.component';
import { MedicalHistory } from '../../../../../shared/models/medical-history';
import { Pagination } from '../../../../../shared/models/pagination.model';
import { MedicalHistoryService } from './../../../../../services/medical-history/medical-history.service';

@Component({
  selector: 'app-medical-history-section',
  imports: [
    MedicalHistoryModalComponent,
    ButtonModule,
    CardComponent,
    DatePipe
  ],
  templateUrl: './medical-history-section.component.html',
  styleUrl: './medical-history-section.component.scss'
})
export class MedicalHistorySectionComponent implements OnInit {
  readonly petId = input.required<string>();

  readonly isModalOpen = signal<boolean>(false);
  readonly isModalDeleteMode = signal<boolean>(false);

  readonly isCardLoading = signal<boolean>(true);
  readonly selectedMedicalHistory = signal<MedicalHistory | null>(null);
  readonly medicalHistories = signal<MedicalHistory[]>([]);

  readonly nextPage = signal<number>(0);
  readonly totalMedicalHistories = signal<number>(0);


  constructor(private readonly medicalHistoryService: MedicalHistoryService,
    private readonly messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.fetchMedicalHistory(0, true);
  }

  onModalOpen(isModalDelete: boolean, idx: number | null = null, event: MouseEvent | null = null): void {
    if (event) {
      event.stopPropagation();
    }

    this.selectedMedicalHistory.set(idx !== null ? this.medicalHistories()[idx] : null);
    this.isModalDeleteMode.set(isModalDelete);
    this.isModalOpen.set(true);
  }

  fetchMedicalHistory(page: number, resetList: boolean = false): void {
    this.isCardLoading.set(true);
    this.medicalHistoryService.paginateMedicalHistoryByPetId(this.petId(), page)
      .pipe(finalize(() => this.isCardLoading.set(false)))
      .subscribe({
        next: (medicalHistoryPage: Pagination<MedicalHistory>) => {
          if (resetList) {
            this.medicalHistories.set(medicalHistoryPage.rows);
            this.nextPage.set(1);
          } else {
            this.medicalHistories.update(prev => [...prev, ...medicalHistoryPage.rows]);
            this.nextPage.update(prev => prev + 1);
          }

          this.totalMedicalHistories.set(medicalHistoryPage.count);
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao recuperar histórico médico',
            life: 4000
          });
        }
      });
  }
}
